import { FC } from "react";

interface CheckboxOption {
  value: string;
  label: string;
  checked: boolean;
}

interface FormCheckboxFieldProps {
  options: CheckboxOption[];
  name: string;
  label?: string;
  type: "checkbox" | "radio";
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormCheckboxField: FC<
  FormCheckboxFieldProps & {
    label?: string;
  }
> = ({ options, name, label, type, onChange }) => {
  return (
    <div className="flex w-full flex-col">
      <span className="mb-2.5 text-sm font-medium leading-[22px] tracking-[-0.01em] text-[#232323]">
        {label}
      </span>
      {options.map((option) => (
        <label key={option.value} className="mb-2 flex items-center">
          <input
            type={type}
            name={name}
            value={option.value || ""}
            checked={!!option.checked}
            onChange={onChange}
            className="mr-2"
          />
          <span className="text-sm leading-[22px] tracking-[-0.01em] text-[#232323]">
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
};
